import * as React from "react";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { AccountBalance, EventBusy, ShowChart } from "@mui/icons-material";
import { API_DATE_FORMAT } from "../hooks/useLoadAllData";

function MetricCard({ label, value, caption, icon: Icon }) {
    return (
        <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {label}
                    </Typography>
                    <Icon color="action" fontSize="small" />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    {value}
                </Typography>
                {caption && (
                    <Typography variant="caption" color="text.secondary">
                        {caption}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}

export default function Main() {
    const exchanges = useSelector((state) => state.exchanges.managedExchanges);
    const indices = useSelector((state) => state.indexes.managedIndexes);
    const nonDisabledIndices = indices.filter((x) => !x.disabled_from);
    const securities = useSelector(
        (state) => state.securities.managedSecurities,
    );
    const today = DateTime.local().toFormat(API_DATE_FORMAT);
    const tomorrow = DateTime.local()
        .plus({ days: 1 })
        .toFormat(API_DATE_FORMAT);
    const yesterday = DateTime.local()
        .minus({ days: 1 })
        .toFormat(API_DATE_FORMAT);

    return (
        <Box sx={{ p: 2.5 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <MetricCard
                        label="Active Indices"
                        value={nonDisabledIndices.length}
                        icon={ShowChart}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <MetricCard
                        label="Managed Securities"
                        value={securities.length}
                        icon={AccountBalance}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MetricCard
                        label="Exchanges Closed Yesterday"
                        value={
                            exchanges.filter((x) => !x.trade_dates[yesterday])
                                .length
                        }
                        caption={yesterday}
                        icon={EventBusy}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MetricCard
                        label="Exchanges Closed Today"
                        value={
                            exchanges.filter((x) => !x.trade_dates[today])
                                .length
                        }
                        caption={today}
                        icon={EventBusy}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MetricCard
                        label="Exchanges Closed Tomorrow"
                        value={
                            exchanges.filter((x) => !x.trade_dates[tomorrow])
                                .length
                        }
                        caption={tomorrow}
                        icon={EventBusy}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
